import { Text, Button, Icon } from '@servicetitan/design-system';
import classNames from 'classnames';
import { tokens } from '@servicetitan/tokens/core';
import { observer } from 'mobx-react';
import * as Styles from './flow-card-styles.module.less';
import { FlowCardWrapper, FlowCardCommonProps } from './flow-card-wrapper';

interface FlowCardCTAProps extends FlowCardCommonProps {
    ctaText: string;
    className?: string;
    onCTAClick(): void;
}

export const FlowCardCTA = observer((props: FlowCardCTAProps) => {
    const {
        isOpen,
        header,
        index,
        isComplete,
        active,
        hasError,
        description,
        ctaText,
        onCTAClick,
    } = props;
    const indexContainer = active || isOpen ? 'bg-blue' : 'bg-blue-grey';
    const editable = isComplete && !isOpen;
    const headerElement = (
        <div className="d-f flex-row align-items-start">
            {editable || hasError ? (
                <Icon
                    size={24}
                    color={hasError ? tokens.colorRed500 : tokens.colorGreen}
                    name={hasError ? 'error' : 'check_circle'}
                />
            ) : (
                <div
                    className={classNames(
                        Styles.tag,
                        'd-f fs-3 justify-content-center align-items-center c-white',
                        indexContainer
                    )}
                >
                    {index}
                </div>
            )}
            <div className="d-i m-l-2">
                <Text className="fs-4 lh-display">{header}</Text>
                {!(isComplete && !isOpen) && <Text className="fs-3 m-t-2-i">{description}</Text>}
            </div>
            {isOpen ? (
                <div className={Styles.ctaContainer}>
                    <Button outline primary onClick={onCTAClick}>
                        {ctaText}
                    </Button>
                </div>
            ) : (
                editable && (
                    <Button className="m-l-auto" outline small onClick={onCTAClick}>
                        Edit
                    </Button>
                )
            )}
        </div>
    );

    return <FlowCardWrapper headerElement={headerElement} {...props} />;
});
